module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-form-box"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "hdiv"
  }, [_c('a', {
    attrs: {
      "href": "http://jazpan.com"
    }
  }, [_c('img', {
    staticClass: "hdlogo",
    attrs: {
      "src": "//static.jazpan.com/img/logo1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v("夹子盘登录")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录\n          ")])], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "login-link-box"
  }, [_c('div', [_vm._v("记住我\n              "), _c('el-switch', {
    model: {
      value: (_vm.ruleForm2.remember),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "remember", $$v)
      },
      expression: "ruleForm2.remember"
    }
  })], 1), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://jazpan.com"
    }
  }, [_vm._v("忘记密码")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-wxlg",
    on: {
      "click": function($event) {
        return _vm.$refs.wxLoginDlg.show()
      }
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/weixinlg.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("微信登录")])])])], 1)], 1)]), _vm._v(" "), _c('WxLoginDlg', {
    ref: "wxLoginDlg",
    on: {
      "submitOK": function($event) {
        return _vm.$router.push(_vm.redirect || '/')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c8a1058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 1158
// module chunks = 1